/**
 * Date-range helpers for the resubmission queries. The UTC-day boundaries mirror the day math the
 * backend resolver used to compute itself (via `setUTCHours(0, 0, 0, 0)`), so moving the range to
 * the frontend leaves the dashboard's visible set unchanged.
 */
export const startOfTodayUtc = (): Date => {
    const date = new Date();
    date.setUTCHours(0, 0, 0, 0);
    return date;
};

/** Start of the next UTC day — the exclusive upper bound covering all of today's resubmissions. */
export const endOfTodayUtc = (): Date => {
    const date = startOfTodayUtc();
    date.setUTCDate(date.getUTCDate() + 1);
    return date;
};

/**
 * Lower bound that includes every past resubmission, regardless of the day it was scheduled. The
 * notification bell uses this so advisers see all overdue resubmissions, not just today's.
 */
export const beginningOfTime = (): Date => new Date(0);

// upper bound covering every future resubmission (bell due timer)
export const endOfTime = (): Date => new Date('9999-12-31T23:59:59.999Z');
